"use strict";
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductType = exports.OrderStatus = void 0;
//==============================================================
// START Enums and Input Objects
//==============================================================
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["DISABLED"] = "DISABLED";
    OrderStatus["ENABLED"] = "ENABLED";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var ProductType;
(function (ProductType) {
    ProductType["CHECKBOX"] = "CHECKBOX";
    ProductType["COUNTER"] = "COUNTER";
    ProductType["CUSTOM"] = "CUSTOM";
    ProductType["RADIO"] = "RADIO";
    ProductType["SELECT"] = "SELECT";
    ProductType["SINGLE"] = "SINGLE";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
